let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajD4l")).then(() => parcelRequire('d65VT'));